import React from "react";
import { Navigate, useParams } from "react-router-dom";

/** Preserves bookmarks after `/provider/locations` → `/provider/facilities` rename. */
export const ProviderLegacyLocationsListRedirect: React.FC = () => (
  <Navigate to="/provider/facilities" replace />
);

export const ProviderLegacyLocationsDetailRedirect: React.FC = () => {
  const { providerId } = useParams<{ providerId: string }>();
  if (!providerId?.trim()) {
    return <Navigate to="/provider/facilities" replace />;
  }
  return <Navigate to={`/provider/facilities/${providerId}`} replace />;
};
